export const GAMEOVER_NUMBER = 7;
export const ALPHABET_ARR = 'abcdefghijklmnopqrstuvwxyz☼☺☽☃'.split('');
export const WORDS = [
  'think',
  'people',
  'other',
  'first',
  'thing',
  'woman',
  'child',
  'after',
  'world',
  'school',
  'three',
  'state',
  'never',
  'become',
  'really',
  'family',
  'leave',
  'great',
  'group',
  'begin',
  'every',
  'start',
  'place',
  'system',
  'right',
  'small',
  'number',
  'night',
  'point',
  'today',
  'bring',
  'happen',
  'before',
  'large',
  'under',
  'water',
  'write',
  'mother',
  'money',
  'story',
  'young',
  'month',
  'right',
  'study',
  'though',
  'issue',
  'black',
  'little',
  'house',
  'after',
  'since',
  'around',
  'friend',
  'father',
  'until',
  'power',
  'often',
  'among',
  'stand',
  'member',
  'almost',
  'later',
  'white',
  'least',
  'learn',
  'change',
  'minute',
  'right',
  'social',
  'watch',
  'follow',
  'around',
  'parent',
  'create',
  'public',
  'speak',
  'others',
  'level',
  'allow',
  'office',
  'spend',
  'health',
  'person',
  'party',
  'within',
  'result',
  'change',
  'reason',
  'early',
  'before',
  'moment',
  'force',
  'offer',
  'enough',
  'across',
  'second',
  'maybe',
  'toward',
  'policy',
  'music',
  'appear',
  'human',
  'serve',
  'market',
  'expect',
  'sense',
  'build',
  'nation',
  'death',
  'course',
  'behind',
  'reach',
  'local',
  'remain',
  'effect',
  'class',
  'raise',
  'little',
  'field',
  'former',
  'major',
  'along',
  'report',
  'better',
  'effort',
  'decide',
  'strong',
  'heart',
  'leader',
  'light',
  'voice',
  'whole',
  'police',
  'return',
  'price',
  'report',
  'carry',
  'drive',
  'break',
  'better',
  'thank',
  'value',
  'action',
  'model',
  'season',
  'early',
  'player',
  'agree',
  'record',
  'paper',
  'space',
  'ground',
  'event',
  'whose',
  'matter',
  'center',
  'couple',
  'table',
  'court',
  'teach',
  'figure',
  'street',
  'image',
  'itself',
  'phone',
  'either',
  'cover',
  'quite',
  'clear',
  'piece',
  'recent',
  'doctor',
  'worker',
  'movie',
  'north',
  'simply',
  'third',
  'catch',
  'source',
  'nearly',
  'choose',
  'cause',
  'point',
  'window',
  'listen',
  'animal',
  'factor',
  'decade',
  'shoot',
  'seven',
  'artist',
  'scene',
  'stock',
  'career',
  'eight',
  'beyond',
  'happy',
  'occur',
  'media',
  'ready',
  'simple',
  'accept',
  'answer',
  'argue',
  'chance',
  'energy',
  'period',
  'course',
  'summer',
  'plant',
  'likely',
  'short',
  'letter',
  'choice',
  'place',
  'single',
  'south',
  'floor',
  'church',
  'close',
  'future',
  'wrong',
  'anyone',
  'myself',
  'sport',
  'board',
  'fight',
  'throw',
  'second',
  'order',
  'author',
  'focus',
  'blood',
  'agency',
  'nature',
  'color',
  'store',
  'reduce',
  'sound',
  'before',
  'enter',
  'share',
  'common',
  'other',
  'series',
  'amount',
  'staff',
  'growth',
  'degree',
  'wonder',
  'attack',
  'region',
  'pretty',
  'trade',
  'arrive',
  'lawyer',
  'glass',
  'answer',
  'skill',
  'sister',
  'crime',
  'stage',
  'design',
  'state',
  'little',
  'indeed',
  'force',
  'truth',
  'check',
  'public',
  'rather',
  'laugh',
  'guess',
  'study',
  'prove',
  'entire',
  'design',
  'enough',
  'forget',
  'since',
  'claim',
  'remove',
  'close',
  'sound',
  'enjoy',
  'legal',
  'final',
  'green',
  'memory',
  'above',
  'trial',
  'expert',
  'spring',
  'radio',
  'visit',
  'avoid',
  'close',
  'finish',
  'theory',
  'impact',
  'charge',
  'reveal',
  'weapon',
  'peace',
  'apply',
  'shake',
  'manage',
  'chair',
  'camera',
  'weight',
  'treat',
  'affect',
  'inside',
  'style',
  'adult',
  'worry',
  'range',
  'rather',
  'writer',
  'middle',
  'dream',
  'stuff',
  'detail',
  'method',
  'hotel',
  'heavy',
  'cause',
  'tough',
  'exist',
  'agent',
  'owner',
  'ahead',
  'cancer',
  'coach',
  'total',
  'finger',
  'garden',
  'notice',
  'modern',
  'civil',
  'budget',
  'mouth',
  'victim',
  'threat',
  'smile',
  'score',
  'break',
  'dinner',
  'figure',
  'relate',
  'travel',
  'debate',
  'front',
  'admit',
  'senior',
  'assume',
  'alone',
  'suffer',
  'speech',
  'option',
  'fresh',
  'forest',
  'video',
  'global',
  'reform',
  'access',
  'judge',
  'credit',
  'corner',
  'recall',
  'stare',
  'safety',
  'troop',
  'income',
  'track',
  'basic',
  'strike',
  'plane',
  'nobody',
  'object',
  'labor',
  'refer',
  'client',
  'touch',
  'please',
  'attend',
  'sleep',
  'press',
  'spirit',
  'brain',
  'dozen',
  'along',
  'battle',
  'sorry',
  'crisis',
  'stick',
  'define',
  'easily',
  'vision',
  'status',
  'normal',
  'stone',
  'slowly',
  'scale',
  'driver',
  'drink',
  'front',
  'handle',
  'truck',
  'return',
  'survey',
  'winter',
  'refuse',
  'sales',
  'screen',
  'future',
  'middle',
  'shape',
  'reader',
  'crowd',
  'horse',
  'target',
  'prison',
  'guard',
  'terms',
  'demand',
  'share',
  'flight',
  'inside',
  'emerge',
  'quick',
  'light',
  'pound',
  'basis',
  'bright',
  'guest',
  'sample',
  'title',
  'mostly',
  'lesson',
  'faith',
  'river',
  'living',
  'count',
  'unless',
  'marry',
  'order',
  'border',
  'gather',
  'block',
  'settle',
  'while',
  'highly',
  'limit',
  'claim',
  'worth',
  'critic',
  'aspect',
  'result',
  'insist',
  'annual',
  'affair',
  'until',
  'spread',
  'ignore',
  'belief',
  'murder',
  'review',
  'editor',
  'engage',
  'coffee',
  'speed',
  'cross',
  'anyway',
  'commit',
  'female',
  'youth',
  'afraid',
  'native',
  'broad',
  'twice',
  'charge',
  'grade',
  'focus',
  'smile',
  'quiet',
  'dress',
  'aware',
  'drive',
  'active',
  'extend',
  'chief',
  'below',
  'voter',
  'demand',
  'remind',
  'moral',
  'visit',
  'depend',
  'bottom',
  'island',
  'clean',
  'studio',
  'train',
  'damage',
  'plate',
  'press',
  'start',
  'alive',
  'intend',
  'attack',
  'abuse',
  'extra',
  'danger',
  'desire',
  'injury',
  'paint',
  'direct',
  'fight',
  'climb',
  'sweet',
  'engine',
  'fourth',
  'expand',
  'metal',
  'ticket',
  'urban',
  'mental',
  'lunch',
  'farmer',
  'above',
  'sugar',
  'planet',
  'obtain',
  'enemy',
  'invite',
  'repeat',
  'panel',
  'alone',
  'pocket',
  'breath',
  'sight',
  'cover',
  'adopt',
  'works',
  'belong',
  'advice',
  'empty',
  'trail',
  'novel',
  'breast',
  'human',
  'theme',
  'storm',
  'union',
  'record',
  'thanks',
  'fruit',
  'under',
  'yellow',
  'prime',
  'shadow',
  'dance',
  'photo',
  'direct',
  'daily',
  'famous',
  'flower',
  'supply',
  'fully',
  'actor',
  'birth',
  'search',
  'circle',
  'device',
  'front',
  'limit',
  'being',
  'shift',
  'locate',
  'county',
  'bridge',
  'train',
  'trend',
  'profit',
  'angry',
  'muscle',
  'notion',
  'prefer',
  'truly',
  'earth',
  'chest',
  'search',
  'thick',
  'museum',
  'beauty',
  'unique',
  'ethnic',
  'stress',
  'select',
  'actual',
  'bottle',
  'hardly',
  'launch',
  'dress',
  'defend',
  'matter',
  'judge',
  'sheet',
  'ought',
  'ensure',
  'extent',
  'chief',
  'brown',
  'shirt',
  'pilot',
  'estate',
  'guide',
  'steal',
  'pursue',
  'funny',
  'blame',
  'crazy',
  'chain',
  'branch',
  'relief',
  'manner',
  'rating',
  'golden',
  'motion',
  'gender',
  'solve',
  'equal',
  'forth',
  'frame',
  'except',
  'trust',
  'ocean',
  'score',
  'afford',
  'regime',
  'appeal',
  'mirror',
  'tooth',
  'smart',
  'length',
  'topic',
  'issue',
  'range',
  'secret',
  'nurse',
  'aside',
  'master',
  'check',
  'stand',
  'clear',
  'clean',
  'except',
  'doubt',
  'grant',
  'cloud',
  'winner',
  'volume',
  'travel',
  'pepper',
  'below',
  'cheap',
  'beach',
  'divide',
  'oppose',
  'route',
  'league',
  'upper',
  'tired',
  'employ',
  'dance',
  'fewer',
  'apart',
  'match',
  'barely',
  'sector',
  'beside',
  'black',
  'proud',
  'waste',
  'merely',
  'wheel',
  'female',
  'invest',
  'cable',
  'expose',
  'rural',
  'narrow',
  'cream',
  'solid',
  'noise',
  'grass',
  'either',
  'drink',
  'accuse',
  'useful',
  'secret',
  'reject',
  'talent',
  'taste',
  'escape',
  'height',
  'assess',
  'sleep',
  'plenty',
  'first',
  'sharp',
  'lower',
  'behind',
  'campus',
  'proper',
  'guilty',
  'living',
  'column',
  'signal',
  'honor',
  'regard',
  'twenty',
  'knock',
  'review',
  'offer',
  'asset',
  'prayer',
  'cheese',
  'permit',
  'bread',
  'scream',
  'deeply',
  'green',
  'lucky',
  'agenda',
  'unable',
  'arrest',
  'brief',
  'steel',
  'shout',
  'visual',
  'fairly',
  'silent',
  'layer',
  'later',
  'slide',
  'widely',
  'inform',
  'bother',
  'enable',
  'saving',
  'desert',
  'shall',
  'error',
  'double',
  'print',
  'formal',
  'album',
  'joint',
  'reply',
  'cycle',
  'whole',
  'stream',
  'trust',
  'grand',
  'hello',
  'knife',
  'racial',
  'phase',
  'potato',
  'quote',
  'online',
  'elect',
  'jacket',
  'rarely',
  'shift',
  'touch',
  'sauce',
  'priest',
  'shock',
  'adjust',
  'retire',
  'habit',
  'juice',
  'attach',
  'coach',
  'severe',
  'impose',
  'other',
  'entry',
  'symbol',
  'still',
  'trade',
  'maker',
  'total',
  'usual',
  'anger',
  'round',
  'clinic',
  'smell',
  'light',
  'tomato',
  'butter',
  'block',
  'surely',
  'tower',
  'smoke',
  'glance',
  'fellow',
  'smooth',
  'nearby',
  'shape',
  'coast',
  'silver',
  'watch',
  'inner',
  'junior',
  'rather',
  'throat',
  'salary',
  'swing',
  'pretty',
  'strike',
  'plant',
  'unlike',
  'resist',
  'supply',
  'assist',
  'viewer',
  'mayor',
  'secure',
  'smoke',
  'fifth',
  'favor',
  'weigh',
  'recipe',
  'wooden',
  'false',
  'honest',
  'essay',
  'giant',
  'origin',
  'advise',
  'count',
  'depth',
  'wealth',
  'shell',
  'onion',
  'deputy',
  'brand',
  'assure',
  'award',
  'dealer',
  'arise',
  'armed',
  'phrase',
  'stake',
  'dream',
  'fiber',
  'switch',
  'minor',
  'killer',
  'assign',
  'label',
  'index',
  'draft',
  'heaven',
  'rough',
  'drama',
  'wonder',
  'clock',
  'sweep',
  'house',
  'button',
  'ahead',
  'super',
  'yield',
  'fence',
  'paint',
  'bottom',
  'bunch',
  'found',
  'burden',
  'react',
  'string',
  'taste',
  'cheek',
  'match',
  'resort',
  'tissue',
  'broken',
  'apple',
  'track',
  'virus',
  'stupid',
  'occupy',
  'cousin',
  'blind',
  'white',
  'honor',
  'retain',
  'latter',
  'slave',
  'terror',
  'though',
  'elite',
  'bullet',
  'tight',
  'chart',
  'solar',
  'square',
  'stick',
  'gently',
  'strip',
  'detect',
  'likely',
  'market',
  'salad',
  'pause',
  'remote',
  'bench',
  'lover',
  'newly',
  'imply',
  'mutual',
  'pride',
  'mainly',
  'freeze',
  'ideal',
  'worth',
  'singer',
  'evolve',
  'partly',
  'smell',
  'thirty',
  'crash',
  'craft',
  'treaty',
  'double',
  'fault',
  'loose',
  'prior',
  'relax',
  'stair',
  'proof',
  'sudden',
  'dirty',
  'tongue',
  'alter',
  'target',
  'stable',
  'appeal',
  'split',
  'steady',
  'vital',
  'stress',
  'adapt',
  'honey',
  'round',
  'vessel',
  'tribe',
  'shelf',
  'buyer',
  'dining',
  'wisdom',
  'garlic',
  'poetry',
  'doubt',
  'scared',
  'guide',
  'since',
  'fellow',
  'slight',
  'shade',
  'mount',
  'angle',
  'differ',
  'custom',
  'store',
  'damage',
  'carbon',
  'closer',
  'scheme',
  'crack',
  'galaxy',
  'given',
  'trace',
  'meter',
  'arrest',
  'rapid',
  'hunter',
  'infant',
  'fifty',
  'porch',
  'waste',
  'derive',
  'fabric',
  'rifle',
  'trick',
  'asleep',
  'tennis',
  'nerve',
  'barrel',
  'ratio',
  'humor',
  'glove',
  'modest',
  'delay',
  'stroke',
  'scope',
  'badly',
  'prompt',
  'absorb',
  'eager',
  'across',
  'cotton',
  'motor',
  'flavor',
  'float',
  'orange',
  'assert',
  'blade',
  'print',
  'cabin',
  'valley',
  'yours',
  'pitch',
  'versus',
  'lemon',
  'hungry',
  'sense',
  'wander',
  'submit',
  'naked',
  'legacy',
  'shrug',
  'flame',
  'wound',
  'shower',
  'depict',
  'flesh',
  'garage',
  'borrow',
  'comedy',
  'twelve',
  'weekly',
  'grain',
  'brush',
  'devote',
  'crack',
  'seize',
  'ethics',
  'summit',
  'gifted',
  'medium',
  'grant',
  'shore',
  'basket',
  'powder',
  'ghost',
  'cookie',
  'swing',
  'orange',
  'awful',
  'admire',
  'exceed',
  'rhythm',
  'lovely',
  'script',
  'tactic',
  'crash',
  'piano',
  'margin',
  'mouse',
  'chase',
  'brick',
  'patch',
  'horror',
  'swear',
  'defeat',
  'slice',
  'sacred',
  'exact',
  'uncle',
  'square',
  'soccer',
  'tunnel',
  'grave',
  'virtue',
  'abroad',
  'makeup',
  'couch',
  'legend',
  'shine',
  'upset',
  'remark',
  'resign',
  'reward',
  'gentle',
  'organ',
  'invent',
  'tight',
  'ritual',
  'insect',
  'salmon',
  'favor',
  'magic',
  'combat',
  'brush',
  'jeans',
  'flour',
  'bitter',
  'slope',
  'subtle',
  'bishop',
  'delay',
  'candy',
  'final',
  'medal',
  'export',
  'curve',
  'logic',
  'harsh',
  'closet',
  'greet',
  'favor',
  'murder',
  'retail',
  'march',
  'snake',
  'pitch',
  'excuse',
  'cross',
  'online',
  'daily',
  'flash',
  'elbow',
  'deadly',
  'plead',
  'sixth',
  'suburb',
  'unlike',
  'trunk',
  'rumor',
  'render',
  'cloth',
  'reach',
  'plain',
  'fraud',
  'array',
  'strict',
  'burst',
  'speed',
  'motive',
  'label',
  'flood',
  'notice',
  'arena',
  'laugh',
  'drift',
  'drain',
  'hurry',
  'temple',
  'medium',
  'random',
  'wrist',
  'domain',
  'guilt',
  'cattle',
  'fiscal',
  'skirt',
  'hence',
  'endure',
  'strain',
  'guitar',
  'behave',
  'dancer',
  'guard',
  'await',
  'spill',
  'grace',
  'colony',
  'slide',
  'closed',
  'towel',
  'modify',
  'award',
  'glance',
  'prize',
  'boost',
  'alarm',
  'weird',
  'sweat',
  'outer',
  'drunk',
  'survey',
  'stuff',
  'govern',
  'ballot',
  'praise',
  'injure',
  'nearby',
  'pause',
  'excuse',
  'chaos',
  'short',
  'canvas',
  'forty',
  'matter',
  'lobby',
  'format',
  'trait',
  'turkey',
  'abuse',
  'thumb',
  'unity',
  'convey',
  'twist',
  'finish',
  'shame',
  'rebel',
  'frozen',
  'desire',
  'spouse',
  'fluid',
  'resume',
  'sodium',
  'bounce',
  'click',
  'signal',
  'pickup',
  'carve',
  'needle',
  'belly',
  'scare',
  'timing',
  'ankle',
  'rescue',
  'firmly',
  'rider',
  'poster',
  'crawl',
  'oxygen',
  'magic',
  'donor',
  'pastor',
  'opera',
  'frame',
  'punish',
  'giant',
  'equity',
  'nwrong',
  'statue',
  'repair',
  'decent',
  'clerk',
  'rescue',
  'purple',
  'laser',
  'eating',
  'parade',
  'realm',
  'strip',
  'cancel',
  'blend',
  'slice',
  'pizza',
  'debate',
  'candle',
  'handle',
  'worry',
  'entity',
  'inside',
  'vanish',
  'trail',
  'racism',
  'casual',
  'enroll',
  'value',
  'intent',
  'civic',
  'steep',
  'alien',
  'scary',
  'angel',
  'switch',
  'repair',
  'toilet',
  'hidden',
  'tender',
  'lonely',
  'silly',
  'shared',
  'pillow',
  'spread',
  'ruling',
  'lately',
  'ranch',
  'softly',
  'verbal',
  'tribal',
  'import',
  'spring',
  'divine',
  'elder',
  'genius',
  'quest',
  'juror',
  'broker',
  'credit',
  'shock',
  'stiff',
  'output',
  'please',
  'toxic',
  'grief',
  'rocket',
  'donate',
  'inmate',
  'tackle',
  'senior',
  'carpet',
  'bubble',
  'buddy',
  'sword',
  'flash',
  'glory',
  'faint',
  'queen',
  'input',
  'bloody',
  'defeat',
  'steam',
  'accent',
  'escape',
  'unite',
  'equip',
  'shrimp',
  'bless',
  'bonus',
  'mixed',
  'orbit',
  'grasp',
  'spite',
  'voting',
  'patrol',
  'trace',
  'wagon',
  'sheer',
  'prior',
  'immune',
  'exotic',
  'secure',
  'thigh',
  'drawer',
  'regard',
  'sheep',
  'runner',
  'empire',
  'catch',
  'whale',
  'draft',
  'skull',
  'puzzle',
  'tragic',
  'safely',
  'eleven',
  'bureau',
  'breeze',
  'costly',
  'object',
  'spell',
  'insert',
  'booth',
  'helmet',
  'waist',
  'royal',
  'panic',
  'crush',
  'cliff',
  'casino',
  'tumor',
  'charge',
  'pulse',
  'fixed',
  'diary',
  'irony',
  'spoon',
  'midst',
  'alley',
  'upset',
  'rival',
  'punch',
  'hockey',
  'known',
  'purse',
  'liquid',
  'foster',
  'cheat',
  'access',
  'fever',
  'filter',
  'rabbit',
  'dried',
  'shove',
  'stove',
  'alike',
  'dough',
  'outfit',
  'patent',
  'quote',
  'trash',
  'gross',
  'pencil',
  'spray',
  'banker',
  'beast',
  'eighth',
  'behalf',
  'shark',
  'reward',
  'fleet',
  'stance',
  'compel',
  'debut',
  'ideal',
  'scent',
  'stack',
  'cease',
  'nasty',
  'shrink',
  'model',
  'wheat',
  'fierce',
  'aisle',
  'weaken',
  'vocal',
  'openly',
  'unfair',
  'deploy',
  'risky',
  'pasta',
  'genre',
  'merit',
  'chunk',
  'ladder',
  'jungle',
  'invade',
  'wound',
  'robot',
  'flood',
  'sphere',
  'boast',
  'major',
  'unfold',
  'collar',
  'streak',
  'added',
  'sneak',
  'monkey',
  'mentor',
  'sleeve',
  'debris',
  'parish',
  'blank',
  'hunger',
  'dying',
  'faster',
  'spare',
  'regret',
  'carrot',
  'cling',
  'blink',
  'squad',
  'plunge',
  'color',
  'chill',
  'refuge',
  'steer',
  'rally',
  'cheer',
  'outlet',
  'intact',
  'vendor',
  'thrive',
  'peanut',
  'steak',
  'comply',
  'awake',
  'strain',
  'patron',
  'liver',
  'solely',
  'banana',
  'palace',
  'cruise',
  'mobile',
  'plain',
  'widow',
  'beard',
  'brake',
  'forbid',
  'brutal',
  'valid',
  'forum',
  'enact',
  'round',
  'thread',
  'light',
  'coming',
  'suite',
  'remark',
  'straw',
  'apart',
  'globe',
  'circle',
  'blast',
  'denial',
  'rental',
  'level',
  'screw',
  'warmth',
  'liquid',
  'yield',
  'battle',
  'drill',
  'cruel',
  'regard',
  'grape',
  'charm',
  'loyal',
  'pound',
  'radar',
  'frown',
  'regain',
  'leave',
  'permit',
  'rubber',
  'freely',
  'update',
  'spark',
  'beyond',
  'marker',
  'preach',
  'bucket',
  'blond',
  'marble',
  'twist',
  'mutter',
  'depart',
  'arrow',
  'trauma',
  'ribbon',
  'screen',
  'within',
  'ridge',
  'brave',
  'crowd',
  'dense',
  'sunny',
  'shorts',
  'swell',
  'soften',
  'sudden',
  'bride',
  'hazard',
  'seldom',
  'launch',
  'weave',
  'timber',
  'flying',
  'devil',
  'cargo',
  'spine',
  'seller',
  'public',
  'marine',
  'boring',
  'fatal',
  'bronze',
  'drown',
  'praise',
  'kneel',
  'vacuum',
  'sensor',
  'manual',
  'pistol',
  'naval',
];
